import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import FilledInput from '@material-ui/core/FilledInput';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { NavLink,useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import Header from '../Headers/Header';
import ErrorMessage from '../AppLayouts/ErrorMessage';
import Cookies from 'js-cookie';
import API_PATH from "../../constants/config.json";
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

//Start Forgotpassword component code ....
export default function Forgotpassword() {
  const [spacing, setSpacing] = React.useState(2);
  const [errMsg, setErrMsg] = React.useState(null);
  const [errEmail, setErrEmail] = React.useState(false);
  const [errMsgEmail, setErrMsgEmail] = React.useState(null);
  const [errPopUp, setErrPopUp] = React.useState(false);
  const [errMsgType, setErrMsgType] = React.useState('error');
  const [disableBtn, setDisableBtn] = React.useState(true);
  const [loader, setLoader] = React.useState(false);
  const [values, setValues] = React.useState({
    email: "",
  });
  let history = useHistory();  


  const handleChange = name => event => { // get values from form
    setErrEmail(false);
    setValues({ ...values, [name]: event.target.value });

    setErrMsg(null);
    setErrEmail(false);  
    let checkEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!checkEmail.test(event.target.value)) {
      setErrEmail(true);
      setErrMsgEmail('Please enter a valid email address');
    } else {
        setDisableBtn(false);
        // requestCode();
    }
  }

  // method to show error message popup ...
  const ShowErrPopUP = () => { 
    setErrPopUp(false);
  };
  // method to show error message popup ...

  //This method use for form validations start ...
  const validateForm = async e => {
    console.log("hello")
    // requestCode();
    
  }
  //This method use for form validations end ...


  // API call to request verification code to recover password .. start
  const requestCode = () => { 
    setLoader(true);
    try {
      axios({
        method: 'post',
        data: {'email' :  values.email},
        url: API_URL + API_PATH.forgotPasswordAPI,
      })
        .then(async function (response) {
          if (response.status && response.status == '200') {
            await Cookies.set('email', values.email);
            history.push('/reset_password');
          } else {
            setErrMsgType('error')
            setErrMsg('Something went wrong.');
            setErrPopUp(true)
            setLoader(false);
          }
        })
        .catch(function (error) {
          if (error.response) {
            setErrMsgType('error');
            setErrMsg(error.response.data.message.message);
            setErrPopUp(true);
            setLoader(false);
          } else {
            setErrMsgType('error');
            setErrMsg('Something went wrong.');
            setErrPopUp(true);
            setLoader(false);
          }
        })
    } catch (error) {
      console.error(error);
    }
  }
  // API call to request verification code to recover password .. end
  

  return (
    <React.Fragment>
      {/* <Header /> */}
      <CssBaseline />
      <div className="signin-main">
        <Container maxWidth="sm" className="user-form-container">
          <Typography component="div">
            <div className="form-logo">
              <NavLink to="/" title='Close'><img className="close-icon" src={require('../../assets/icons/close.svg')} /></NavLink>
              <img src={require('../../assets/images/dataPointLogo.svg')} className="form-icon"></img>
            </div>
            <form className="root-form" noValidate autoComplete="off">
              <h3 className="h3-title">Recover your account</h3>
              <p className="center-text margin-0"><label className="default-label">Or</label> <NavLink to="/sign_in" className="link-label">Back to login</NavLink></p>
              <Grid container className="root-box">
                <Grid item xs={12}>
                    {errMsg ? <ErrorMessage message={errMsg} visible={ShowErrPopUP} show={errPopUp} msgType={errMsgType} /> : null}
                  <Grid container justify="center" spacing={spacing}>
                    <Grid xs={12} item>
                      <Paper className="paper sign-form-message center">
                        <p>Enter your email address used for DataPoint and we will send a link to reset your password</p>
                      </Paper>
                    </Grid>
                    <Grid xs={12} item>
                      <Paper className="paper" >
                        <p className="text-input-label">Email address</p>
                        <FilledInput 
                          id="email" 
                          placeholder="you@example.com" 
                          className={errEmail ? "form-text-input-error" : "form-text-input"} 
                          type="email" variant="outlined" required 
                          onKeyUp={handleChange('email')} 
                          data-testid='email' 
                        //   value={email} 
                          endAdornment={ errEmail && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> }
                        />
                        {errEmail ? <p className="form-error-label">{errMsgEmail}</p> : null}
                      </Paper>
                    </Grid>
                    <Grid xs={12} item>
                      <Paper className="paper" style={{ textAlign: 'center', display: 'block' }} >
                        <Button type="button" variant="outlined" id="signIn_btn" data-testid="forgotPwdBtn" className="blue-btn" disabled={disableBtn} onClick={requestCode} style={{marginTop: '16px'}}>
                          {loader == true ?
                            <CircularProgress />
                            :
                            'Send verification code'
                          }
                        </Button>
                        <div className="signin-divisor"><label>Or</label></div>
                        <p style={{paddingTop: '24px'}} className="margin-0"><NavLink to="/sign_in" data-testid='backToLogin' className="link-label font-16">Back to login</NavLink></p>
                      </Paper>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </form>
          </Typography>
        </Container>
      </div>
    </React.Fragment>
  );
}
//End Forgotpassword component code ....
